class Chateau
	constructor: (options = {}) ->
		@options = _.extend(
			debug: true
		, options)

	initStellar: () ->
		$stellarDivs = $('[data-stellar-background-ratio]')
		if $stellarDivs.length > 0
			$.stellar(
				responsive: true
				horizontalScrolling: false
			)
		return

	initSplash: () ->
		console.log 'initSplash'

		$el = $('#splash-screen')
		$errorMsg = $el.find('.error-message')
		$btnNo = $el.find('.btn-answer-no')
		$btnYes = $el.find('.btn-answer-yes')

		$errorMsg.hide()

		$btnNo.on 'click', ->
			console.log 'no click'
			$errorMsg.show()
			return

		$btnYes.on 'click', ->
			console.log 'yes click'
			if $('#c1').prop('checked') == true
				console.log 'remember me'
				$errorMsg.hide()
				target = $btnYes.data('targetUrl')
				document.cookie = "mmAgeGate=true; path=/";
				window.location = target;
				return
			else
				console.log 'dont remember me'
				$errorMsg.hide()
#				document.cookie = "mmAgeGate=true; expires=0; path=/";

				now = new Date();
				time = now.getTime();
				time += 3600 * 1000;
				now.setTime(time);
				document.cookie =
					'mmAgeGate=true' +
					'; expires=' + now.toUTCString() +
					'; path=/';

				target = $btnYes.data('targetUrl')
				window.location = target;
				return

			return

	initContact: () ->
		$el = $('#contact-us')

		$('#contact-us').on 'click', '#contact-submit', (e) =>
			e.preventDefault()
			$(e.currentTarget).prop('disabled', true)

			#fields to validate
			contactHidden = $(e.delegateTarget).find('#contact-hidden')
			contactEmail = $(e.delegateTarget).find('#contact-email')
			contactSubject = $(e.delegateTarget).find('#contact-subject')
			contactMessage = $(e.delegateTarget).find('#contact-message')
			auth = $(e.delegateTarget).find('#auth')


			$(e.delegateTarget).find('.error-message').remove()
			$(e.delegateTarget).find('.error-border').removeClass('error-border')

			if contactHidden.val() != ""
				return

			# Assume the form is valid
			isValid = true

			if !@validateEmail(contactEmail.val())
#show email error
				contactEmail.before('<span class="error-message">' + contactEmail.attr('data-error-message') + '</span>')
				contactEmail.addClass('error-border')
				isValid = false


			if contactSubject.val() == ""
#show subject error
				contactSubject.before('<span class="error-message">' + contactSubject.attr('data-error-message') + '</span>')
				contactSubject.addClass('error-border')
				isValid = false


			if contactMessage.val() == ""
#show message error
				contactMessage.before('<span class="error-message">' + contactMessage.attr('data-error-message') + '</span>')
				contactMessage.addClass('error-border')
				isValid = false

			if not auth.is(":checked")
#show message error
				auth.before('<span class="error-message block">' + auth.attr('data-error-message') + '</span>')
				auth.addClass('error-border')
				isValid = false


			#Is not valid, do not send data
			if !isValid
				$(e.currentTarget).prop('disabled', false)

				return

			#url to send info to
			url = $(e.delegateTarget).attr('data-url')

			dataToSend = {
				Email: contactEmail.val(),
				Subject: contactSubject.val(),
				Message: contactMessage.val(),
				Hidden: contactHidden.val(),
				Lang: $(e.delegateTarget).find('#contact-lang').val(),
				EmailTo: $(e.delegateTarget).find('#contact-emailto').val()
			}

			dataToSend = JSON.stringify(dataToSend)

			$.ajax(
				type: "POST",
				dataType: "json",
				url: url,
				data: {"model": dataToSend},
				success: (result) ->
					if result.response > 0
						title = $('#contact-us').find('h2')
						$('#contact-us').empty()
						$('#contact-us').append(title)
						$('#contact-us').append('<span>' + $('#contact-us').attr('data-success') + '</span>')

					return

				error: (result) ->


				complete: ->
					$('#contact-submit').prop('disabled', false)
			)

			return

		return

	validateEmail: (email) ->
		re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return re.test(email)

	init: () ->
		@initStellar()
		if $('#splash-screen').length > 0
			@initSplash()
		if $('#contact-us').length > 0
			@initContact()
		if $('.tabbar').length > 0
			@initWhereToBuy()
		return

	initWhereToBuy: () ->
		$('.tabbar').on 'click', 'a', (e) ->
			e.preventDefault()

			_this = $(@)
			_parent = _this.parent()
			_grandparent = _this.closest('nav')
			_child = _parent.data('contact')

			_tabContent = $('.' + _child.toString())
			_parent.siblings().removeClass('active')
			_parent.addClass('active')
			_grandparent.closest('div').find('section.active').removeClass 'active'
			_tabContent.addClass 'active'
		return
